import { ModalConfirmationDialogComponent } from './modal-confirmation-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "@ng-bootstrap/ng-bootstrap";
export class ModalConfirmationDialogService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    confirm(title, message, btnOkText = 'OK', btnCancelText = 'Cancel', dialogSize = 'sm', windowClass) {
        const modalRef = this.modalService.open(ModalConfirmationDialogComponent, { size: dialogSize, windowClass });
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.btnOkText = btnOkText;
        modalRef.componentInstance.btnCancelText = btnCancelText;
        return modalRef.result;
    }
}
ModalConfirmationDialogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModalConfirmationDialogService_Factory() { return new ModalConfirmationDialogService(i0.ɵɵinject(i1.NgbModal)); }, token: ModalConfirmationDialogService, providedIn: "root" });
